import { RestServiceUtils } from "../utils/RestServiceUtils";

const deviceService = {
    addScreens: (screenIds, organizationId, placeId) => {
        const URL = `/ums/${organizationId}/${placeId}/screens`;
        return RestServiceUtils.HTTP_POST(URL, screenIds, {}, false);
    },

    getScreensDetails: (organizationId, placeId, params) => {
        const URL = `/ums/${organizationId}/${placeId}/screens`;
        return RestServiceUtils.HTTP_GET(URL, params);
    },

    deleteScreens: (organizationId, placeId, screenIds) => {
        const URL = `/ums/${organizationId}/${placeId}/screens`;
        return RestServiceUtils.HTTP_DELETE(URL, screenIds);
    },
};

export default deviceService;
